import { render, staticRenderFns } from "./TemplateEdit.vue?vue&type=template&id=029001d8&scoped=true&lang=pug&"
import script from "./TemplateEdit.vue?vue&type=script&lang=ts&"
export * from "./TemplateEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029001d8",
  null
  
)

export default component.exports